import script from "./CompletionPercentage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CompletionPercentage.vue?vue&type=script&lang=js"
export * from "./CompletionPercentage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CompletionPercentage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/CompletionPercentage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "231896be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('231896be', __exports__)) {
    api.reload('231896be', __exports__)
  }
  
}


export default __exports__